var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadBoxIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 0l2.956 1.193L3.922 6.254a.615.615 0 00-.036.016L.928 5.075 13.501 0zm4.492 1.814l3.587 1.448L8.813 8.417a.594.594 0 00-.283.235.544.544 0 00-.08.346.558.558 0 00-.003.067v6.094l-1.308-1.853a.603.603 0 00-.347-.235.636.636 0 00-.424.041l-1.541.727v-6.71l13.165-5.315zm5.121 2.066l2.96 1.195L13.5 10.15l-2.956-1.193 12.535-5.061a.616.616 0 00.036-.016zM0 5.94L3.62 7.4v7.36a.54.54 0 00.077.277c.05.085.122.156.21.207a.629.629 0 00.586.026l1.936-.915 2.087 2.953.002.004a.593.593 0 00.304.259l.003.002a.648.648 0 00.52-.03l.002-.002a.586.586 0 00.247-.241.542.542 0 00.06-.33V9.837l3.243 1.31V27L0 21.792V5.939zm27 .002v15.85L14.103 27V11.147L27 5.941z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadBoxIconWhite);
export default __webpack_public_path__ + "static/media/LoadBoxIconWhite.20545bc8456a212c6e34fa2c3c2a2837.svg";
export { ForwardRef as ReactComponent };